import { acceptStringValue } from '../../field-viewer/shared-normalizers';
import { validateBirthdate } from './contacts-birthdate/contacts-birthdate-validation';
export const contactsBirthdateViewer = {
    normalizeLoadedValue: acceptStringValue,
    runAdditionalValidation: validateBirthdate
};

//# sourceMappingURL=definition-viewer.js.map